<script>
  import solicitacaoFaturamentoServico from '../servico';
  import Cabecalho from '~componentes/CabecalhoRelatorio.vue';
  import formasPagamento from '../formas-pagamento';
  import Barcode from '@xkeshi/vue-barcode';
  
  export default {
    components: { Cabecalho, Barcode },
    data() {
      return {
        solicitacao: {},
        carregando: true,
        formasPagamento: formasPagamento,
        configuracao: this.$storage.configuracao(),
      }
    },
    methods: {
      carregar: function(id) {
        this.carregando = true;

        solicitacaoFaturamentoServico
          .obterPorId(id)
          .then(solicitacao => {
            this.carregando = false;
            this.solicitacao = solicitacao;
          });
      },
      formaPagamento(id) {
        return this.formasPagamento.find(f => {
          return f.id === id;
        });
      },
    },
    computed: {
      periodoDeVigencia() {
        let dataInicio = this.solicitacao.projeto.dataInicioVigencia;
        let dataTermino = this.solicitacao.projeto.dataTerminoVigencia;

        if (dataInicio === 0 && dataTermino === 0) {
          return '---';
        }

        let periodo = this.$options.filters.formatarNumeroEmData(dataInicio);

        if (dataTermino) {
          periodo += ` - ${this.$options.filters.formatarNumeroEmData(dataTermino)}`;
        }

        return periodo;
      },
      dataLiberacaoCoordenador() {
        return this.$options.filters.formatarNumeroEmDataExtenso(this.solicitacao.liberacaoCoordenador) || '---';
      },
      fusp() {
        return this.configuracao.abreviaturaFundacao.toUpperCase() === 'FUSP';
      },
    },
    created() {
      this.carregar(this.$route.params.id);
    },
    mounted() {
      this.$root.tituloDaPagina = 'Solicitação de Faturamento de Estrangeiro PF - Relatório';
      this.$root.botaoAcaoTexto = 'Imprimir relatório';
      this.$root.botaoAcaoIcon = 'fa-print';
      this.$root.botaoAcaoLink = '';

      this.$root.botaoRetrocederMostrar = true;

      if (this.$route.params.rota)
        this.$root.botaoRetrocederRota = this.$route.params.rota
      else
        this.$root.botaoRetrocederRota = 'solicitacao-faturamento-estrangeiro-pf';

      this.$events.on('botaoAcao', function() {
        window.print();
      });
    },
    beforeDestroy() {
      this.$events.off('botaoAcao');
    }
  }
</script>

<template>
  <div>
    <div :class="'wrapper wrapper-content animated ' + $root.animacaoPadrao" id="relatorio">
      <div class="row">
        <div class="col-lg-12">
          <div class="ibox float-e-margins">
            <div class="ibox-content">
              
              <p v-show="carregando" class="text-center">
                <i class='fa fa-spinner fa-pulse'></i> Carregando...
              </p>

              <div v-if="!carregando">
                <cabecalho :titulo="'Solicitação de Faturamento'"></cabecalho>

                <h3 class="m-t-none m-b">Dados da solicitação</h3>

                <div class="hr-line-dashed margin-top-5"></div>

                <div class="row">
                  <dl class="col-xs-8">
                    <dt>Projeto</dt>
                    <dd>{{ solicitacao.projeto ? solicitacao.projeto.idProjeto : '' }} - {{ solicitacao.projeto ? solicitacao.projeto.nomeProjeto : '' }}</dd>
                  </dl>
                  <dl class="col-xs-4">
                    <dt>Tipo de projeto</dt>
                    <dd>{{ solicitacao.projeto.tipoProjeto ? solicitacao.projeto.tipoProjeto.nome : '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-6">
                    <dt>Período de vigência</dt>
                    <dd>{{ periodoDeVigencia }}</dd>
                  </dl>
                  <dl class="col-xs-6">
                    <dt>Nr. processo</dt>
                    <dd>{{ solicitacao.projeto ? solicitacao.projeto.nrProcesso : '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-3">
                    <dt>Número</dt>
                    <dd>{{ solicitacao.idSolicitacaoFaturamento || '---' }}</dd>
                  </dl>
                  <dl class="col-xs-3">
                    <dt>Data da solicitação</dt>
                    <dd>{{ solicitacao.dataSolicitacao | formatarNumeroEmDataExtenso }}</dd>
                  </dl>
                  <dl class="col-xs-3">
                    <dt>Solicitante</dt>
                    <dd>{{ solicitacao.solicitante ? solicitacao.solicitante.nomePessoaFisicaJuridica : '---' }}</dd>
                  </dl>
                  <dl class="col-xs-3">
                    <dt>Coordenador do projeto</dt>
                    <dd>{{ solicitacao.projeto.coordenador ? solicitacao.projeto.coordenador.nomePessoaFisicaJuridica : '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl :class="[configuracao.criarProtocoloSolicitacao ? 'col-xs-3' : 'col-xs-6']">
                    <dt>Data de liberação do coordenador</dt>
                    <dd>{{ dataLiberacaoCoordenador }}</dd>
                  </dl>
                  <dl :class="[configuracao.criarProtocoloSolicitacao ? 'col-xs-3' : 'col-xs-6']">
                    <dt>Liberado por</dt>
                    <dd>{{ solicitacao.liberadoPor ? solicitacao.liberadoPor.nomePessoaFisicaJuridica : '---' }}</dd>
                  </dl>
                  <dl class="col-xs-3" v-if="configuracao.criarProtocoloSolicitacao && solicitacao.protocolo != null">
                    <dt>Nº protocolo</dt>
                    <dd>{{ solicitacao.protocolo ? solicitacao.protocolo.numeroProtocolo : '---' }}</dd>
                  </dl>
                  <dl class="col-xs-3" v-if="configuracao.criarProtocoloSolicitacao && solicitacao.protocolo != null">
                    <dt>Código de barras protocolo</dt>
                    <dd><barcode :value="solicitacao.protocolo.numeroProtocolo" :options="{ displayValue: false, height: 20, margin: 1 }"></barcode></dd>
                  </dl>
                </div>

                <h3 class="m-t-none m-b">Dados para faturamento</h3>

                <div class="hr-line-dashed margin-top-5"></div>

                <div class="row">
                  <dl class="col-xs-8">
                    <dt>Nome</dt>
                    <dd>{{ solicitacao.nome || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-4">
                    <dt>Email faturamento</dt>
                    <dd>{{ solicitacao.documento }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-6">
                    <dt>Endereço</dt>
                    <dd>{{ solicitacao.enderecoFaturamento || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-3">
                    <dt>Número</dt>
                    <dd>{{ solicitacao.numeroFaturamento || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-3">
                    <dt>Complemento</dt>
                    <dd>{{ solicitacao.complementoFaturamento || '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-4">
                    <dt>Bairro</dt>
                    <dd>{{ solicitacao.bairroFaturamento || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-5">
                    <dt>Cidade</dt>
                    <dd>{{ solicitacao.cidadeFaturamento || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-3">
                    <dt>País</dt>
                    <dd>{{ solicitacao.pais || '---' }}</dd>
                  </dl>
                </div>

                <h3 class="m-t-none m-b">Dados para cobrança</h3>

                <div class="hr-line-dashed margin-top-5"></div>

                <div class="row">
                  <dl class="col-xs-6">
                    <dt>Endereço</dt>
                    <dd>{{ solicitacao.enderecoCobranca || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-3">
                    <dt>Número</dt>
                    <dd>{{ solicitacao.numeroCobranca || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-3">
                    <dt>Complemento</dt>
                    <dd>{{ solicitacao.complementoCobranca || '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-4">
                    <dt>Bairro</dt>
                    <dd>{{ solicitacao.bairroCobranca || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-5">
                    <dt>Cidade</dt>
                    <dd>{{ solicitacao.cidadeCobranca || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-3">
                    <dt>País</dt>
                    <dd>{{ solicitacao.paisCobranca || '---' }}</dd>
                  </dl>
                </div>

                <h3 class="m-t-none m-b">Dados para fatura</h3>

                <div class="hr-line-dashed margin-top-5"></div>

                <div class="row">
                  <dl :class="[fusp ? 'col-xs-6' : 'col-xs-4']">
                    <dt>Data de vencimento</dt>
                    <dd>{{ solicitacao.dataPagamento | formatarNumeroEmData }}</dd>
                  </dl>

                  <dl :class="[fusp ? 'col-xs-6' : 'col-xs-4']">
                    <dt>Forma de pagamento</dt>
                    <dd>{{ formaPagamento(solicitacao.formaPagamento).nome }}</dd>
                  </dl>

                  <dl class="col-xs-2" v-if="!fusp">
                    <dt>Moeda</dt>
                    <dd>{{ solicitacao.moeda ? solicitacao.moeda.nomeMoeda : '---' }}</dd>
                  </dl>

                  <dl class="col-xs-2" v-if="!fusp">
                    <dt>Valor</dt>
                    <dd>{{ solicitacao.valor | formatarNumero }}</dd>
                  </dl>
                </div>

                <div class="row" v-if="!fusp">
                  <dl class="col-xs-4">
                    <dt>Com entrega de documento técnico?</dt>
                    <dd>{{ solicitacao.comDocumentoTecnico ? 'Sim' : 'Não' }}</dd>
                  </dl>

                  <dl class="col-xs-4">
                    <dt>Documento técnico nº</dt>
                    <dd>{{ solicitacao.documentoTecnico || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-4">
                    <dt>Pedido compra ou processo</dt>
                    <dd>{{ solicitacao.pedidoCompraProcesso || '---' }}</dd>
                  </dl>
                </div>

                <div class="row" v-if="!fusp">
                  <dl class="col-xs-12">
                    <dt>Descrição</dt>
                    <dd class="white-space-pre">{{ solicitacao.descricao || '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-12">
                    <dt>Observação</dt>
                    <dd>{{ solicitacao.obsFaturamento || '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-12">
                    <dt>Justificativa</dt>
                    <dd class="white-space-pre">{{ solicitacao.justificativa || '---' }}</dd>
                  </dl>
                </div>

                <hr v-if="fusp">

                <div class="table-responsive" v-if="fusp">
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th>Observação</th>
                        <th>Quantidade</th>
                        <th>Valor(R$)</th>
                        <th>Total(R$)</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(i, indice) in solicitacao.itens">
                        <td class="white-space-pre">{{ i.descricao || '---' }}</td>
                        <td class="text-right">{{ i.quantidade | formatarNumero }}</td>
                        <td class="text-right">{{ i.valor | formatarNumero }}</td>
                        <td class="text-right">{{ (i.quantidade * i.valor) | formatarNumero }}</td>
                      </tr>
                      <tr v-if="solicitacao.itens.length === 0">
                        <td colspan="4" class="text-center">Nenhum item adicionado.</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div class="hr-line-dashed margin-top-5" v-if="this.configuracao.solFaturamentoMsgConfirmacao"></div>

                <div class="row" v-if="this.configuracao.solFaturamentoMsgConfirmacao">
                  <div class="col-md-12">
                    <p><i>{{this.configuracao.solFaturamentoEstrangeiroPFMsgConfirmacao}}</i></p>
                  </div>
                </div>

              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-faturamento-estrangeiro-pf/componentes/SolicitacaoFaturamentoRelatorio.vue